import { t } from "i18next";
import { DataTableData, DataTableHeader } from "../../../../components/deprecated/DataTable/DataTable";

import { FirebaseDataUnitField } from "to-be-removed/LocalData/General/DataObjectField/CustomFields/FirebaseDataUnitField";
import { FirebaseDataDateField } from "to-be-removed/LocalData/General/DataObjectField/Generic/FirebaseDataDateField";
import { FirebaseDataStringField } from "to-be-removed/LocalData/General/DataObjectField/Generic/FirebaseDataStringField";
import { DataObjectField } from "../../General/DataObjectField/DataObjectField";
import { DataObjectHelper } from "../../General/DataObjects/DataObjectHelper";
import { LocalData } from "../../General/LocalData";
import { PropertyData } from "../PropertyData";
import BookingData from "./BookingData";

export class BookingDataHelper extends DataObjectHelper<BookingData> {
  id = () => "booking";

  bookingOwnerUnit = new FirebaseDataUnitField<BookingData>(
    "bookingOwnerUnit",
    t("main.bookingOwnerUnit"),
    (booking) => booking.bookingOwnerUnit,
    "apartment"
  );
  startDate = new FirebaseDataDateField<BookingData>("startDate", t("main.startDate"), (booking) => booking.startDate, "today");
  endDate = new FirebaseDataDateField<BookingData>("startDate", t("main.endDate"), (booking) => booking.endDate, "event");
  state = new FirebaseDataStringField<BookingData>("state", t("main.status"), (booking) => booking.state, "pending");
  bookingNumber = new FirebaseDataStringField<BookingData>("bookingNumber", t("main.bookingNumber"), (booking) => booking.bookingNumber, "pin");

  allFields(): DataObjectField<any, BookingData>[] {
    return [this.bookingOwnerUnit, this.startDate, this.endDate, this.state, this.bookingNumber];
  }
  displayName(): string {
    return t("main.booking");
  }

  override getAllDatas(): BookingData[] {
    const bookings: BookingData[] = [];
    for (const property of LocalData.currentUser.properties) {
      for (const booking of property.bookings.documents) {
        bookings.push(booking);
      }
    }
    return bookings;
  }

  getAllDataTableDatas(documents: BookingData[]): DataTableData[] {
    return documents.map((booking) => {
      return {
        key: booking.id,
        cells: {
          bookingOwnerUnit: booking.bookingOwnerUnit?.name,
          startDate: booking.startDate,
          endDate: booking.endDate,
          bookingState: booking.state,
          bookingNumber: booking.bookingNumber,
        },
      };
    });
  }

  loadAll(): Promise<any> {
    const allPromises: Promise<any>[] = [];

    let properties: PropertyData[] = LocalData.currentUser.properties;

    for (const property of properties) {
      const promise = new Promise<BookingData[]>((resolve) => {
        property.bookings.load((bookings) => {
          resolve(bookings);
        });
      });
      allPromises.push(promise);
    }
    return Promise.all(allPromises);
  }

  getAllDataTableHeaders(): DataTableHeader[] {
    return [
      {
        key: "bookingOwnerUnit",
        title: t("main.bookingOwnerUnit"),
      },
      {
        key: "startDate",
        title: t("main.startDate"),
      },
      {
        key: "endDate",
        title: t("main.endDate"),
      },
      {
        key: "bookingState",
        title: t("main.status"),
      },
      {
        key: "bookingNumber",
        title: t("main.bookingNumber"),
      },
    ];
  }
}

